import { runClientComponent } from '../../_common/client/client-component-runner';
import { HideBorderIfEmptyComponent } from './hide-border-if-empty.component';

runClientComponent({ HideBorderIfEmptyComponent: HideBorderIfEmptyComponent });
